import api from './api';

const whatsappService = {
  async getSettings() {
    const response = await api.get('/v1/me/whatsapp/settings');
    return response.data;
  },

  async updateSettings(settings) {
    // settings: { enabled, templateStyle, messageNotes, notifyOnPublicCreate, notifyOnPrivateCreate,
    //             reminderEnabled, reminderHoursBefore, reminderRespectBusinessHours,
    //             reminderBusinessStart, reminderBusinessEnd }
    const response = await api.put('/v1/me/whatsapp/settings', settings);
    return response.data;
  },

  async listMessages(page = 1, pageSize = 20) {
    const response = await api.get('/v1/me/whatsapp/messages', { params: { page, pageSize } });
    return response.data;
  },

  // ── Conversas do WhatsApp (sino do header) — contrato: §5.5 de docs/PLANO-EXECUCAO-CONVERSAS-WHATSAPP.md ──

  async getInboxUnreadCount() {
    // { unread } — recebidas não lidas em todas as conversas
    const response = await api.get('/v1/me/whatsapp/conversations/unread-count');
    return response.data;
  },

  async listConversations({ limit = 20, before = null, q = '' } = {}) {
    // { items:[{ key, phone, personId, displayName, unread, lastMessage }], unreadTotal, hasMore }
    // before = lastMessage.createdAt da última conversa já mostrada ("carregar mais"); q = busca (nome ou telefone)
    const params = { limit };
    if (before) params.before = before;
    if (q && q.trim()) params.q = q.trim();
    const response = await api.get('/v1/me/whatsapp/conversations', { params });
    return response.data;
  },

  async listConversationMessages(key, { before = null, limit = 50 } = {}) {
    // { key, items:[mais antiga → mais nova], hasMore } — before = createdAt da mais antiga já carregada
    const params = { limit };
    if (before) params.before = before;
    const response = await api.get(`/v1/me/whatsapp/conversations/${encodeURIComponent(key)}/messages`, { params });
    return response.data;
  },

  async markConversationRead(key) {
    // 204 — marca como lidas as recebidas da conversa
    await api.post(`/v1/me/whatsapp/conversations/${encodeURIComponent(key)}/read`);
  },

  async getCreditStatement(windowDays = 30) {
    // { entries:[{id,source,qty,remaining,createdAt,expiresAt,productName}],
    //   purchases:[{intentId,productId,productName,creditQty,priceCents,status,createdAt,fulfilledAt,
    //               method /* 'Pix'|'CreditCard'|null — null = compra antiga, era PIX */,
    //               optionCode /* forma de pagamento da compra; null = antes das formas no banco */}],
    //   daily:[{date,consumed,refunded}], windowDays }
    const response = await api.get('/v1/me/whatsapp/credits/statement', { params: { windowDays } });
    return response.data;
  },

  async getModels() {
    // [{ id, name, previewCreated, previewCreatedWithNotes }]
    const response = await api.get('/v1/me/whatsapp/models');
    return response.data;
  },
};

export default whatsappService;
